"use strict";
/**
 *  timeCueModule Module
 *
 * Description 策划中心 信息监控 实时线索 近期政策
 * rebuild: SMG 2016-5-24
 */
angular.module('recentPolicyModule', [])
    .controller('recentPolicyController', ["$scope", "$filter", "$q", "$modal", "$state", "$stateParams", "trsHttpService", "$timeout", "planningCenterService", "calendarService", "uiCalendarConfig", "modalDialog", "storageListenerService", function($scope, $filter, $q, $modal, $state, $stateParams, trsHttpService, $timeout, planningCenterService, calendarService, uiCalendarConfig, modalDialog, storageListenerService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
            };
            $scope.data = {
                myDate: new Date(),
                recentpolicy: {
                    items: "",
                    curPolicy: "china",
                    policyType: {
                        "china": "get",
                        "zj": "getzj",
                    }
                },
                eventSources: [],
                events: []
            };
            $scope.params = {
                typeid: "widget",
                serviceid: "recentpolicy",
                modelid: "search",
                page_no: $scope.page.CURRPAGE - 1,
                page_size: $scope.page.PAGESIZE,
                area: $scope.data.recentpolicy.curPolicy,
                search_word: "",
                search_date: ""
            };
            $scope.status = {
                params: {
                    "PageSize": $scope.page.PAGESIZE,
                    "CurrPage": $scope.page.CURRPAGE,
                },
                copyCurrPage: 1,
                currTrench: "getCustomList",
                curTime: $filter('date')(Date.parse(new Date()), "yyyy-MM-dd").toString(),
                lastDay: new Date($scope.data.myDate.getFullYear(), $scope.data.myDate.getMonth() + 1, 0).getDate(),
                isExisted: {}
            };
            $scope.dropDown = {};
            $scope.data.eventSources = [$scope.data.events];

            $scope.moreType = ["website", "weixin"];
            $scope.isSelectedDetail = "";
            $scope.isShowDiscloseConfig = true;
            $scope.monitors = [];

        }

        function initData() {
            // initCalendar();
            // initCalendarData();
            getRecentPolicyList();
            initDropDown();
            // weiboDiscloseFun();
            // getAllAddedMonitors();
            listenStorage();
            getTenantInfo();
        }
        /**
         * [getTenantInfo description] 获取租户信息
         * @return {[type]} [description]
         */
        function getTenantInfo() {
            var params = {
                serviceid: "mlf_tenant",
                methodname: "findTenantById"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                var area;
                if (angular.isString(data.MEMO) && data.MEMO.indexOf(";") > 0) {
                    area = data.MEMO.split(";");
                    $scope.status.tenantArea = { name: area[0], value: area[1] };
                } else {
                    $scope.status.tenantArea = { name: '新疆', value: "zj" }
                }
            });
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenPlan(function() {
                //initCalendarData();
                storageListenerService.removeListener("plan");
            });
        }

        /**
         * [refresh description]分别刷新各项列表，自定义，近期政策，近期灾害与历史今天
         * @return {[type]} [description]null
         */
        function refresh() {
            eval($scope.status.currTrench + "()");
        }

        /**
         * [initDropDown description]下拉框初始化
         * @return {[type]} [description]null
         */
        function initDropDown() {
            //初始化选择日期
            $scope.dropDown.selectedMonth = planningCenterService.monthSource();
            //下拉框获得的是当前月份
            $scope.dropDown.selectedMonthDefault = angular.copy($scope.dropDown.selectedMonth[new Date().getMonth()]);
            //获取当前年份以及以后10年
            $scope.dropDown.selectedYear = planningCenterService.yearSource();
            $scope.dropDown.selectedYearDefault = angular.copy($scope.dropDown.selectedYear[0]);
        }

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function() {
            if ($scope.data.fromdate) {
                $scope.params.search_date = $scope.data.fromdate + ";" + $scope.data.untildate;
            } else {
                $scope.params.search_date = '';
            }
            getRecentPolicyList();
        };


        /**
         * [getRecentPolicy description]点击近期政策，近期政策相关操作开始
         * @return {[type]} [description]
         */
        $scope.getRecentPolicy = function(type) {
            $scope.$broadcast('clearDateWithOutCallback', {});
            if ($scope.data.recentpolicy.curPolicy == type) return;
            delete $scope.data.fromdate;
            delete $scope.data.untildate;
            $scope.params.search_date = "";
            $scope.params.search_word = "";
            $scope.status.currTrench = "getRecentPolicyList";
            $scope.data.recentpolicy.curPolicy = type;
            $scope.status.params.CurrPage = $scope.page.CURRPAGE = 1;
            $scope.params.area = $scope.data.recentpolicy.curPolicy;
            $scope.params.page_no = 0;
            getRecentPolicyList();
        };

        /*
         * [getRecentPolicyList description]获得近期政策列表
         * @param  {[str]} time [description]请求时间
         * @return {[type]}      [description]null
         */
        function getRecentPolicyList() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) { //ll
                $scope.indexname = data.CONTENT.INDEXNAME;
                $scope.data.recentpolicy.items = data.PAGEDLIST.PAGEITEMS;
                $scope.page.ITEMCOUNT = data.PAGEDLIST.TOTALITEMCOUNT;
                $scope.page.PAGECOUNT = data.PAGEDLIST.TOTALPAGECOUNT;
                storageListenerService.previewPageTurningStorage($scope.data.recentpolicy.items, "ZB_GUID", "resourceDetail");
            });
        }
        /**
         * [timeStamp description] 格式化日期
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.timeStamp = function(item) {
            return $filter("date")(item.URLDATE, "yyyy-MM-dd HH:mm:ss");
        };

        /**
         * [pageChanged description]近期政策的分页，近期政策功能结束
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1; //re
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            getRecentPolicyList();
        };

        $scope.selectPageNum = function() {
            $scope.params.page_no = $scope.page.CURRPAGE - 1;
            $scope.params.page_size = $scope.page.PAGESIZE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            getRecentPolicyList();
        };
        /**
         * [jumpToPage description:跳转指定页面]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            } else if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.page_no = $scope.status.copyCurrPage - 1;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            getRecentPolicyList();
        };

        /**
         * [textSearch:检索]
         */
        $scope.textSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.params.CurrPage = $scope.page.CURRPAGE = 1;
                if ($scope.data.fromdate) {
                    $scope.params.search_date = $scope.data.fromdate + ";" + $scope.data.untildate;
                } else {
                    $scope.params.search_date = '';
                }
                getRecentPolicyList();
            }
        };

    }]);